<ish-info-box
  heading="account.ordertemplates.widget.heading"
  class="infobox-wrapper h-100"
  cssClass="infobox-color-widget d-flex flex-column"
>
  <div class="loading-container">
    @if ((loading$ | async) !== true) {
    <div class="pb-2">
      @if (orderTemplates$ | async; as orderTemplates) { @if (orderTemplates.length) { @for (orderTemplate of
      orderTemplates; track orderTemplate) {
      <div class="mb-2">
        <a [routerLink]="['/account/order-templates/', orderTemplate.id]">{{ orderTemplate.title }}</a>
        @if (orderTemplate.items?.length) {
        <a class="align-top float-right">
          <ish-product-add-to-basket
            ishProductContext
            [parts]="getParts(orderTemplate)"
            displayType="icon"
            cssClass="p-0 mb-0"
          />
        </a>
        }
      </div>
      } } @else {
      {{ 'account.order_template.list.no_templates.text' | translate }}
      } } @else {
      {{ 'account.order_template.list.no_templates.text' | translate }}
      }
    </div>
    } @else {
    <ish-loading />
    }
  </div>

  <div class="mt-auto">
    <a routerLink="/account/order-templates" data-testing-id="order-templates-list-link">
      {{ 'account.ordertemplates.widget.view_all.link' | translate }}
    </a>
  </div>
</ish-info-box>
